export default "__VITE_ASSET__e1609ae3__"